import { EpicIcons } from "@constellation-academy/epic-ui";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import { Button } from "../../../components/button";
import { Paths } from "../../../routes/paths";

type OwnProps = {
	productId: string;
};

export const EditProductButton = ({ productId }: OwnProps) => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	return (
		<Button
			icon={EpicIcons.PENCIL}
			tooltip={t("product.editTooltip")}
			onClick={() => {
				navigate(Paths.products.withId(productId).edit.path);
			}}
		/>
	);
};
